import { SEOHandle } from "@nasa-gcn/remix-seo";

import Breadcrumb from "~/components/breadcrumb/Breadcrumb";
import CallToAction from "~/components/callToAction/CallToAction";
import { useLanguage } from "~/context/LanguageContext";
import { getLocalizedPagePath } from "~/helpers/navigationHelper";
import generateSitemapEntriesFor from "~/helpers/sitemapEntriesWithLocal";
import { rootMeta } from "~/root.meta";

import ArticleBody from "./components/articleBody/ArticleBody";
import ArticleConclusion from "./components/articleConclusion/ArticleConclusion";
import ArticleIntroduction from "./components/articleIntroduction/ArticleIntroduction";
import i18n from "./i18n";

export function meta() {
  return [{ title: "SkillSynergy | Fundamental programming" }, ...rootMeta];
}

export const handle: SEOHandle = generateSitemapEntriesFor(
  "/course/programming",
);

export default function BlogPage() {
  const { lang } = useLanguage();
  const t = i18n[lang];

  return (
    <>
      <Breadcrumb
        title={t.title}
        page={t.pageTitle}
        parent={t.parentTitle}
        parentLink={getLocalizedPagePath("/courses")}
        backgroundImg="/img/hero/case_study_details_bg.webp"
      />
      <ArticleIntroduction />
      <ArticleBody />
      <ArticleConclusion />
      <CallToAction fullWidth={true} backgroundImage="/img/cta/cta_bg_5.webp" />
    </>
  );
}
